'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('main.sa_group_edit', {
        url: 'sa_group/:id',
        template: '<sa-group-edit></sa-group-edit>'
    });
};



// WEBPACK FOOTER //
// ./public/dev/app/sa_group/edit/sa_group_edit.routes.js